<template>
  <div>
    <div class="flex flex-col max-w-screen-xl sm:gap-2 boundary h-full bg-white mx-5 sm:m-auto">
      <slot />
    </div>
  </div>
</template>

<script setup>
defineProps(["path"]);
</script>
